import React from "react";
import RightPannel from "../../../components/RightPannel";
import { useNavigate } from "react-router-dom";
import BloodSugarRange from "../../../../../Diathrive/src/containers/BloodSugarRange";

const MyBloodSugarRange = ({ openMyBSR, setOpenMyBSR }) => {
  const navigate = useNavigate();

  return (
    <RightPannel
      componentToPassDown={
        <BloodSugarRange
          navigation={navigate}
          route={{}}
          onClose={() => setOpenMyBSR(false)}
        />
      }
      open={openMyBSR}
      onClose={() => setOpenMyBSR(false)}
    />
  );
};

export default MyBloodSugarRange;
